export class JobMatchAction {
    constructor(action, actionType, allowed, message) {
        this.action = action;
        this.actionType = actionType;
        this.allowed = allowed;
        this.message = message;
    }
}
//# sourceMappingURL=jobMatchAction.js.map